import axios from 'axios';
import axiosError from '../../axios-error.vue';
import loadingAnimation from '../../loading-animation.vue';
import collectionHeader from '../collection-header.vue';
import quickLinks from '../quick-links.vue';
import uptCollectionGrid from './upt-collection-grid.vue';

export default {
  name: 'uptCollectionContainer',
  components: {
    CollectionHeader: collectionHeader,
    QuickLinks: quickLinks,
    uptCollectionGrid: uptCollectionGrid,
    LoadingAnimation: loadingAnimation,
    AxiosError: axiosError,
  },
  props: ['collectionId', 'sideBySide', 'cBanners'],
  data() {
    return {
      bundleBuilder: [],
      isLoading: true,
      error: false,
      uptDrawerClosed: false,
      sectiondata: {},
      uptGlobal: {},
      productGroups: [],
      quickLinkList: [],
      colorwaySort: 'default',
      hideFullPriceForSales: false,
      hideHeroSection: false,
      showDiscModal: false,
      bundleReqsMet: false,
      showMaxMetModal: false,
      scrollY: 0,
      minScroll: 200,
      maxScroll: 900
    };
  },
  watch: {
    //changes the product's in-bundle status when it is added or removed from the bundle
    bundleBuilder: {
      handler(newValue, oldValue) {
        // const reqsMet = this.checkIfBundleReqsMet();
        // if (reqsMet) {
        //   this.bundleReqsMet = true;
        // } else {
        //   false;
        // }
        this.checkIfBundleReqsMet();
      },
      deep: true,
    },
  },
  computed: {
    isInScrollRange() {
      return this.scrollY >= this.minScroll && this.scrollY <= this.maxScroll;
    },
    allGroupsHaveOneProduct() {
      return this.productGroups.every(group => group.products.length === 1);
    }
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY || window.pageYOffset;
      //console.log('Scroll position:', this.scrollY);
    },
    updateScrollRange() {
      const width = window.innerWidth;

      if (width >= 992) {
        // Desktop
        this.minScroll = 72;
        this.maxScroll = 900;
      }  else {
        // narrow
        this.minScroll = 72;
        this.maxScroll = 200;
      }

      console.log(`Screen width: ${width}, scroll range: ${this.minScroll}-${this.maxScroll}`);
    },
    //get the products
    getCollection() {
      let targetdomain = window.location.hostname.includes(
        'development.cotopaxi.com'
      )
        ? 'https://development-access-api.cotopaxi.com'
        : 'https://production-access-api.cotopaxi.com';

      let previewParam = new URL(window.location.href).searchParams.get(
        'preview_upt'
      );
      let discountId = previewParam ? '/' + previewParam : '';
      axios
        // if visibility param is provided, call the API with that attached.
        .get(
          targetdomain +
            `/collection/getUptCollectionByShopifyCollectionId/${this.collectionId}` +
            discountId
        )
        .then((response) => {
          if (response.data.sections) {
            this.sectiondata = response.data.sections;
            if (response.data.sections.showQuickLinks) {
              this.quickLinkList = response.data.sections.quickLinks;
            }
          }
          if (this.sectiondata.colorwayGroupSortOrder) {
            this.colorwaySort = this.sectiondata.colorwayGroupSortOrder;
          }
          if (this.sectiondata.hideHeroSection) {
            this.hideHeroSection = this.sectiondata.hideHeroSection;
          }
          this.uptGlobal = response.data;
          this.productGroups = response.data.groups;

          //for each group, determine the min and max quanity of products to qualify for promo
          this.productGroups.forEach((group) => {
            this.findMinAndMaxOfGroup(group);
          });

          this.createBundleBuilder(this.productGroups);

          //this.productData = response.data.products;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },

    getQuicklinkUrl(groupIndex, qlinkIndex) {
      //get current url
      let url = new URL(window.location.href);
      //get quicklink from group  using group index and link index from loops in vue file
      const qlink =
        this.productGroups[groupIndex].quickLinks.links[qlinkIndex].link;

      // if no '?' in current url, add on ?tag=whatever
      if (!url.search.includes('?')) {
        url.search += '?tag=${qlink}';
      } else {
        //if a '?' does exist either replace tag=whatever if it exists or add tag=whatever on to params
        const urlParams = url.searchParams;
        urlParams.set('tag', qlink);
        url.search = urlParams.toString();
      }

      return url.href;
    },
    checkIfBundleReqsMet() {
      //for each group look at the minimum quantity
      // if min has been met for ALL groups, reqs have been met
      let numOfEachGroupInBundle = [];
      let numOfEachGroupToQualify = [];
      this.productGroups.forEach((group, index) => {
        numOfEachGroupToQualify.push(group.min);
        numOfEachGroupInBundle.push(
          this.countBundleItems(this.bundleBuilder, index)
        );
      });

      const qualifies = this.compareArrays(
        numOfEachGroupInBundle,
        numOfEachGroupToQualify
      );
      if (qualifies) {
        this.bundleReqsMet = true;
        this.uptDrawerClosed = false;
      } else {
        this.bundleReqsMet = false;
      }
      //return qualifies;
    },

    //compares number of each in group in bundle to min number of items needed to qualify
    compareArrays(numInBundle, numToQualify) {
      for (let i = 0; i < numInBundle.length; i++) {
        if (numInBundle[i] < numToQualify[i]) {
          return false;
        }
      }
      return true;
    },

    countBundleItems(bundleArr, group) {
      let count = 0;
      bundleArr.forEach((obj) => {
        if (obj.group === group && obj.status === 'filled') {
          count++;
        }
      });
      return count;
    },

    createBundleBuilder(groups) {
      this.bundleBuilder = [];

      groups.forEach((group) => {
        //add an empty bundle item up to max number of items. If max is not set, just add one empty item spot
        const loopLimit =
          group.max === Number.POSITIVE_INFINITY ? 1 : group.max;
        for (let i = 0; i < loopLimit; i++) {
          this.bundleBuilder.push({
            group: groups.indexOf(group),
            productName: '',
            image:
              'https://res.cloudinary.com/cotopaxi/image/upload/v1706127768/AB_Testing/ghost.png',
            size: '',
            variantId: null,
            status: 'empty',
            lastGroup: i === loopLimit - 1 ? true : false,
            saleStatus: null,
          });
        }
      });

      this.findBreaksBetweenGroups(this.bundleBuilder);
    },

    deleteBundleItem(bundleItem) {
      //find the product to delete
      let itemToDelete = this.bundleBuilder.find((item) => item === bundleItem);

      //determine if group has infinite max or not
      let infiniteMax = false;
      if (this.productGroups[itemToDelete.group].max === Infinity) {
        infiniteMax = true;
      }

      //determine if product were deleting is the last one of its group
      let lastItemInGroup = false;

      let count = 0;
      this.bundleBuilder.forEach((obj) => {
        if (obj.group === itemToDelete.group) {
          count++;
        }
      });

      if (count <= 1) {
        lastItemInGroup = true;
      }

      //if no infinite max or it's the last of the products for the product's groups,
      //just replace it's contents with empty item details so we keep the bundle skeleton
      //otherwise remove it from array so we don't have a ton of empty boxes
      if (!infiniteMax || lastItemInGroup) {
        (itemToDelete.productName = ''),
          (itemToDelete.image =
            'https://res.cloudinary.com/cotopaxi/image/upload/v1706127768/AB_Testing/ghost.png'),
          (itemToDelete.size = ''),
          (itemToDelete.variantId = null),
          (itemToDelete.status = 'empty');
      } else {
        const indexOfItemToDelete = this.bundleBuilder.indexOf(itemToDelete);
        this.bundleBuilder.splice(indexOfItemToDelete, 1);
      }

      //reconfigure where the plus signs go
      this.findBreaksBetweenGroups(this.bundleBuilder);
    },

    // find the minimum minimum
    findMinAndMaxOfGroup(group) {
      const tiers = group.tiers;
      let lowestMin = Infinity;
      let largestMax = -Infinity;
      for (const tier in tiers) {
        // Skip inactive tiers
        if (tiers[tier].active === false) {
          continue;
        }

        const { min, max } = tiers[tier];

        if (min < lowestMin) {
          lowestMin = min;
        }
        if (max === null || max === Number.POSITIVE_INFINITY) {
          largestMax = Number.POSITIVE_INFINITY;
        } else if (max > largestMax) {
          largestMax = max;
        }
      }
      group.min = lowestMin;
      group.max = largestMax;
    },

    //find breaks determine where the plus signs go in the bundle UI
    findBreaksBetweenGroups(bundleBuilder) {
      for (let i = 0; i < bundleBuilder.length; i++) {
        const current = bundleBuilder[i];
        const next = bundleBuilder[i + 1];
        const lastGroup = this.productGroups.length - 1;
        //loop through bundle to determine if the object is the last of its group
        //but not the last group, so we can add a class to have the + break up the groups
        if (next && next.group != current.group && current.group != lastGroup) {
          current.class = 'plus';
        } else {
          current.class = null;
        }
      }
    },

    addBundleToCart() {
      // create list of items from bundleBuilder
      // using flatMap() because we want to manipulate the array while also
      // potentially removing items from it
      const items = this.bundleBuilder.flatMap((item) => {
        if (item.status === 'filled') {
          return {
            quantity: 1,
            id: item.variantId,
            properties: {
              _saleStatus: item.saleStatus,
            },
          };
          // empty array will essentially remove the item from the map array
        } else return [];
      });
      // add items
      vueSideCart.addItems(items);
      // refresh bundle builder
      this.createBundleBuilder(this.productGroups);
    },

    addProductToBundle(product) {
      //figure out which group the product is in
      const productGroup = this.findProductGroup(product.shopifyProductId);
      let infiniteMax = false;

      if (this.productGroups[productGroup].max === Infinity) {
        infiniteMax = true;
      }

      //find the first spot in bundleBuilder which matches the group number and is status empty.
      let emptyBundleSpot = this.bundleBuilder.find(
        (item) => item.group === productGroup && item.status === 'empty'
      );

      const itemVariantId = this.getVariantId(product);

      //set the empty bundle spot with its new data
      if (emptyBundleSpot) {
        emptyBundleSpot.productName = product.title;
        emptyBundleSpot.image =
          product.activeColor === 'delDia'
            ? product.delDiaVersion.featuredImage
            : product.featuredImage;
        emptyBundleSpot.size = product.activeSize;
        emptyBundleSpot.variantId = itemVariantId;
        emptyBundleSpot.status = 'filled';
        emptyBundleSpot.saleStatus = product.colorwayStatus;
      } else if (!emptyBundleSpot && infiniteMax === true) {
        //if there are no empty bundle spots, but you haven't hit the max
        const newBundleItem = {
          group: productGroup,
          productName: product.title,
          image:
            product.activeColor === 'delDia'
              ? product.delDiaVersion.featuredImage
              : product.featuredImage,
          size: product.activeSize,
          variantId: itemVariantId,
          status: 'filled',
          saleStatus: product.colorwayStatus,
        };

        this.insertProductIntoBundleBuilder(
          this.bundleBuilder,
          newBundleItem,
          productGroup
        );

        this.findBreaksBetweenGroups(this.bundleBuilder);
        //this.bundleBuilder.push(newBundleItem);
      }

      //if there are no empty spots, but max is infinity we want to add a new empty spot to the bundle builder
      let emptyBundleSpots = 0;
      this.bundleBuilder.forEach((item) => {
        if (item.status === 'empty' && item.group === productGroup) {
          emptyBundleSpots++;
        }
      });

      if (emptyBundleSpots === 0 && infiniteMax === true) {
        let newEmptyObj = {
          group: productGroup,
          productName: '',
          image:
            'https://res.cloudinary.com/cotopaxi/image/upload/v1706127768/AB_Testing/ghost.png',
          size: '',
          variantId: null,
          status: 'empty',
          lastGroup: true,
          saleStatus: null,
        };
        this.insertProductIntoBundleBuilder(
          this.bundleBuilder,
          newEmptyObj,
          productGroup
        );
      }

      //determine if we've hit max number of a group and jump down to next group
      let filledBundleSpots = 0;
      this.bundleBuilder.forEach((item) => {
        if (item.status === 'filled') {
          filledBundleSpots++;
        }
      });

      if (filledBundleSpots === 1) {
        this.uptDrawerClosed = false;
      }

      //Scroll to nextgroup
      if (filledBundleSpots >= this.productGroups[productGroup].max) {
        const anchor = document.getElementById(`group-${productGroup + 1}`);
        const yOffset = -60;
        if (anchor) {
          const y =
            anchor.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }

      //display warning modal if you try to add products once the group max is already met
      if (!emptyBundleSpot && infiniteMax === false) {
        this.showMaxMetModal = true;
      }

      this.findBreaksBetweenGroups(this.bundleBuilder);
    },

    insertProductIntoBundleBuilder(arr, newItem, prodGroup) {
      let lastIndex = -1;

      //find the last index of product group
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].group === prodGroup) {
          lastIndex = i;
          //remove plus class from previous last item in group
          // arr[i].class = 'null';
          break;
        }
      }

      //insert new item after the last index of the item's group
      arr.splice(lastIndex + 1, 0, newItem);
    },

    getVariantId(bundleItem) {
      //del dia products seem to all be set up differently so lots of options in here
      if (
        bundleItem.activeColor === 'delDia' ||
        bundleItem.activeColor.includes('Del Día')
      ) {
        //check if del dia product has the delDiaVersion property and get variantID from there
        if (bundleItem.delDiaVersion) {
          return bundleItem.delDiaVersion.shopifyVariantId;
        } else if (!bundleItem.delDiaVersion) {
          //del dia will only have 1 colorway/size so get variant ID from there
          return bundleItem.colorways[0].sizes[0].shopifyVariantId;
        }
      } else {
        //non-del dia products, find the variant ID from colorway/size combo
        const colorway = bundleItem.colorways.find(
          (color) => color.name === bundleItem.activeColor
        );
        const size = colorway.sizes.find(
          (sz) => sz.name === bundleItem.activeSize
        );
        return size.shopifyVariantId;
      }
    },

    findProductGroup(shopifyId) {
      for (let i = 0; i < this.productGroups.length; i++) {
        const group = this.productGroups[i];
        for (let j = 0; j < group.products.length; j++) {
          const product = group.products[j];
          if (product.shopifyProductId === shopifyId) {
            return i;
          }
        }
      }
      return -1;
    },
  },
  mounted() {
    this.getCollection();
    setTimeout(() => {
        //if (this.sideBySide) return; //don't close it on sidebyside
        this.uptDrawerClosed = true;
      }, 3000);
    //console.log('show side by side: ' + this.sideBySide);
    this.updateScrollRange();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.updateScrollRange);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateScrollRange);
  }
};
